import React, { Component } from 'react';
import { connect } from 'react-redux';
import ReactPaginate from 'react-paginate';
import { limpiarFiltros } from '../../actions/generalActios';
import { fetchSellersFilter } from '../../actions/sellersActions';
import { fetchOrdenes, setFiltroOrdenes } from '../../actions/ordenesActions';
import OrdenListItem from './OrdenListItem';
import FiltroOrdenes from './FiltroOrdenes';
import BigSpinner from "../General/BigSpinner";
import BtnToggleFilter from "../General/Filter/BtnToggleFilter";
import { filtroMedioMes } from '../../utilities/fechasFiltro';
import { formatoDecimal } from '../../utilities/formatoNumeros';
const fechaFiltro = filtroMedioMes();

class ListOrdenes extends Component {
    constructor(props) {
        super(props);
        this.state = {
            currentPage: 1,
            onFilter: true,
            request: {
                idSeller: this.props.idSeller,
                numeroPagina: 1,
                documento: "",
                idOrden: "",
                nombre: "",
                apellido: "",
                fechaDesde: fechaFiltro.desde,
                fechaHasta: fechaFiltro.hasta
            }
        };
        const { isCategory, isSoloLectura, isAdminMod } = this.props.userType;
        this.allowSearchBySeller = isCategory || isSoloLectura || isAdminMod;
    }

    componentDidMount() {

        let estadoInicioFiltraPor_Moderador = { ...this.state.request, idSeller: "" };
        let request = this.props.filtro;

        if (this.props.emptyFiltro.ordenes) {
            if (this.allowSearchBySeller) {
                this.props.setFiltroOrdenes(estadoInicioFiltraPor_Moderador);
                this.setState({ request: estadoInicioFiltraPor_Moderador })
                this.props.fetchOrdenes(estadoInicioFiltraPor_Moderador);
            } else {
                this.props.setFiltroOrdenes(this.state.request);
                this.props.fetchOrdenes(this.state.request);
            }
        } else {
            request.numeroPagina = 1;
            this.props.setFiltroOrdenes(request);
            this.setState({ request: request });
            this.props.fetchOrdenes(request);
        }

        if (this.allowSearchBySeller) {
            this.props.fetchSellersFilter(null);
        }
    }

    onOrden = (id) => {
        let pathReturn = `/Ordenes`
        this.props.history.push({
            pathname: `/Ordenes/Editar/${id}`,
            state: pathReturn
        });
    }

    handlePageClick = (e) => {
        const selectedPage = e.selected + 1;
        const params = {
            ...this.state.request,
            numeroPagina: selectedPage,
            idSeller: this.allowSearchBySeller ? this.props.filtro.idSeller : this.props.idSeller,
        }

        this.setState({ request: params, numeroPagina: selectedPage });
        this.updateRequest(params);
    };

    updateRequest = (request) => {
        let params = { ...this.state, request: request };

        if (!this.allowSearchBySeller) {
            request.idSeller = this.props.idSeller;
            params = { ...this.state, request: request }
        }

        this.setState({ request: params.request, currentPage: params.request.numeroPagina });
        this.props.setFiltroOrdenes(params.request);
        this.props.fetchOrdenes(params.request);
    }


    render() {
        const { userType, ordenes, loadingOrdenes } = this.props;
        const { isAdminMod, isCategory, isSoloLectura } = userType

        const totalizadores = [
            { nombre: 'Total', valor: '$' + formatoDecimal(`${ordenes.montoVentasTotal}`) },
            { nombre: 'Total Comisión', valor: '$' + formatoDecimal(`${ordenes.montoComisionTotal}`) },
            { nombre: 'Cantidad Órdenes', valor: ordenes.cantidadTotal },
        ]

        return (
            <div className="container">
                <div className="row justify-content-between align-items-center page-titles text-center text-md-start">

                    <div className="col-12 col-md-2 mb-md-0 mb-2">
                        <h3 className="text-themecolor color-rojo-megatone">Órdenes</h3>
                    </div>

                    {!isSoloLectura &&
                        <div className="col-12 col-md-auto list-group list-group-horizontal-md">
                            {totalizadores.map((totalizador, index) => {
                                return (
                                    <div key={index} className="list-group-item text-center">
                                        <span className="font-size-073rem d-block pb-1">{totalizador.nombre}</span>
                                        <span className="badge rounded-pill text-bg-primary">{totalizador.valor}</span>
                                    </div>
                                )
                            })
                            }
                        </div>
                    }

                    <BtnToggleFilter show={this.state.onFilter} handleShow={() => this.setState({ onFilter: !this.state.onFilter })} />
                </div>

                <div hidden={!this.state.onFilter}>
                    <FiltroOrdenes
                        filtro={this.props.filtro}
                        updateRequest={this.updateRequest}
                        allowSearchBySeller={isCategory || isSoloLectura || isAdminMod}
                    />
                </div>

                {loadingOrdenes ? <BigSpinner /> :
                    <div>
                        {ordenes?.elementos && ordenes.elementos.length > 0 ?
                            <div className="list-group">
                                {ordenes.elementos.map((orden, index) => {
                                    if (this.props.idSeller === orden.seller.codigo && !isAdminMod) {
                                        return (
                                            <div key={index} onClick={() => { this.onOrden(orden.idOrden) }}>
                                                <OrdenListItem
                                                    mailCliente={""}
                                                    idOrden={orden.idOrden}
                                                    idReferencia={orden.idReferencia}
                                                    seller={orden.seller.descripcion}
                                                    fecha={orden.fecha}
                                                    cliente={orden.cliente.nombre + ' ' + orden.cliente.apellido}
                                                    documento={orden.cliente.documento}
                                                    tipoEntrega={orden.entrega.tipoEntrega.descripcion}
                                                    montoVenta={orden.montoVenta}
                                                    productos={orden.productos}
                                                    estado={orden.estado}
                                                    cuotas={orden.pago.cuotas}
                                                    tarjeta={orden.pago.tarjeta}
                                                    urlLogo={orden.seller.urlLogo}
                                                    anulacionMegatone={orden.anulacionMegatone}
                                                    showComision={false}
                                                />
                                            </div>
                                        )
                                    } else if (isCategory || isAdminMod || isSoloLectura) {
                                        return (
                                            <a key={index} onClick={() => { this.onOrden(orden.idOrden) }}>
                                                <OrdenListItem
                                                    key={index}
                                                    idOrden={orden.idOrden}
                                                    idReferencia={orden.idReferencia}
                                                    seller={orden.seller.descripcion}
                                                    fecha={orden.fecha}
                                                    cliente={orden.cliente.nombre + ' ' + orden.cliente.apellido}
                                                    mailCliente={orden.cliente.email}
                                                    documento={orden.cliente.documento}
                                                    tipoEntrega={orden.entrega.tipoEntrega.descripcion}
                                                    montoVenta={orden.montoVenta}
                                                    productos={orden.productos}
                                                    estado={orden.estado}
                                                    cuotas={orden.pago.cuotas}
                                                    tarjeta={orden.pago.tarjeta}
                                                    urlLogo={orden.seller.urlLogo}
                                                    dniIdBocaSeller={orden.idVendedorBoca}
                                                    plataformaCodigo={orden.plataforma.codigo}
                                                    importeComision={orden.montoComision}
                                                    anulacionMegatone={orden.anulacionMegatone}
                                                    showComision={true}
                                                />
                                            </a>
                                        )
                                    }
                                })
                                }
                            </div>
                            :
                            <h5 className="d-flex justify-content-center my-4">NO SE ENCONTRARON RESULTADOS</h5>
                        }
                    </div>
                }

                <div className="d-flex justify-content-center">
                    <ReactPaginate
                        previousLabel={"Anterior"}
                        nextLabel={"Siguiente"}
                        breakLabel={"..."}
                        breakClassName={"break-me"}
                        pageCount={this.props.ordenes.cantidadTotal / 10}
                        marginPagesDisplayed={5}
                        pageRangeDisplayed={10}
                        onPageChange={this.handlePageClick}
                        containerClassName={"pagination"}
                        subContainerClassName={"pages pagination"}
                        activeClassName={"active"}
                        forcePage={this.state.currentPage - 1}
                    />
                </div>
            </div>
        );
    }
}


const mapStateToProps = state => ({
    userType: state.general.userType,
    idSeller: state.general.idSeller,
    loadingOrdenes: state.ordenes.loadingOrdenes,
    emptyFiltro: state.general.limpiar,
    ordenes: state.ordenes.ordenes,
    filtro: state.ordenes.filtro
});

export default connect(mapStateToProps, {
    fetchOrdenes,
    limpiarFiltros,
    setFiltroOrdenes,
    fetchSellersFilter
})(ListOrdenes);